import { useEffect as o } from "react";
import f from "../useLatest/useLatest.js";
const n = (e) => {
  const t = f(e);
  o(() => () => t.current(), [t]);
};
export {
  n as default
};
//# sourceMappingURL=useUnmount.js.map
